<template>
    <el-button :type="type" v-clipboard:copy="copyContent" v-clipboard:success="onCopy" v-clipboard:error="onError">{{text}}</el-button>
</template>
<script>
export default {
  name: 'pt-copy-button',
  props: {
    copyContent: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    },
    text: {
      type: String,
      default: '复制'
    }
  },
  methods: {
    onCopy (e) {
      this.$message.success('复制成功，请前往您需要的位置粘贴')
    },
    onError (e) {
      this.$message.error('复制失败')
    }
  }
}
</script>
<style module lang="less">

</style>
